import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import {useDispatch, useSelector} from "react-redux";
import {setQueryParam} from "helpers/queryParam";
import TableAutoComplete from "./TableAutoComplete";
import {formatDate} from "../../helpers";
import {apiGetUsers} from "../../api/userApi";

export default function TableSelectUser({
                                            refetch,
                                        }: {
    refetch: (paginationState: any, token: any, userId: any) => void;
}) {
    const fromDate = useSelector((state: any) => state.appReducer.fromDate);
    const toDate = useSelector((state: any) => state.appReducer.toDate);

    const dispatch = useDispatch();

    //@ts-ignore
    const {token} = useSelector((state) => state).businessReducer.business;

    //@ts-ignore
    const userReducer = useSelector((state) => state).userReducer;

    //@ts-ignore
    const paginationState = useSelector((state) => state.paginationReducer);

    React.useEffect(() => {
        // @ts-ignore
        dispatch(apiGetUsers(token));
    }, [token]);

    const onChange = (newValue: any) => {
        if (newValue?.value) {
            //@ts-ignore
            let options = [];
            if (fromDate && toDate) {
                let from = formatDate(fromDate);
                let to = formatDate(toDate);
                options = [
                    {key: "subColumn", value: "date"},
                    {key: "searchText", value: from},
                    {key: "searchTextAlt", value: to},
                ];
            }

            setQueryParam("userId", newValue.value);
            //@ts-ignore
            return dispatch(refetch(paginationState, token, options, null, null, null, newValue.value));
        }
    };

    return (
        <Box
            sx={{
                minWidth: 120,
                maxWidth: 330,
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
            }}
        >
            <FormControl fullWidth sx={{maxWidth: 300}}>
                <TableAutoComplete
                    queryParam="userId"
                    options={userReducer?.users ? userReducer?.users : []}
                    onChange={onChange}
                />
            </FormControl>
        </Box>
    );
}
